<ng-container *ngIf="!!page">
    <tt-tabs *ngIf="'mobile' | mediaQuery" [ttSelectedId]="page.show_last_visited_customers === '1' ? 'LAST' : 'SEARCH'" (ttSelectedIdChange)="onLastCustomersSelectionChanged($event)">
        <tt-tab ttId="LAST" ttLabel="findcustomers_last"></tt-tab>
        <tt-tab ttId="SEARCH" ttLabel="findcustomers_search"></tt-tab>
    </tt-tabs>
    <tt-tabs ttRememberId="w_findcustomer.findcustomers_selection" [ttSelectedId]="page.findcustomers_selection" (ttSelectedIdChange)="onFindCustomersSelectionChanged($event)">
        <tt-tab ttId="A" ttLabel="all"></tt-tab>
        <tt-tab ttId="C" ttLabel="cust_find_customers"></tt-tab>
        <tt-tab ttId="S" ttLabel="cust_find_suppliers"></tt-tab>
        <tt-tab ttId="O" ttLabel="cust_find_other"></tt-tab>
    </tt-tabs>
    <tt-card>
        <tt-field-group [hidden]="page.show_last_visited_customers === '1' && ('mobile' | mediaQuery)">
            <form class="col-6" name="formFindCustomersSearch" (ngSubmit)="readGrid(true)">
                <tt-input
                    ttRememberId="w_findcustomers.cust_name"
                    ttLabel="customer_search"
                    [(ttModel)]="page.cust_name"
                    (ttModelChange)="$event === '' && readGrid()"
                    [ttDisabled]="page.show_last_visited_customers === '1'"
                    ttShowClearButton
                >
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="far fa-search" [ttDisabled]="page.show_last_visited_customers === '1'" (ttClick)="readGrid(true)"></tt-form-field-button>
                    </ng-container>
                </tt-input>
            </form>
            <tt-select
                class="col-6"
                ttRememberId="w_findcustomer.custgrp_id"
                ttLabel="custgrp"
                [(ttModel)]="page.custgrp_id"
                (ttModelChange)="readGrid()"
                [ttDisabled]="page.show_last_visited_customers === '1'"
                [ttData]="customerGroups"
                ttDataId="custgrp_id"
                ttDataName="custgrp_name"
                [ttClearValue]="'ALL'"
                ttShowClearButton
            ></tt-select>
        </tt-field-group>
        <tt-checkbox
            *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery"
            ttLabel="show_last_visited_customers"
            [(ttModel)]="page.show_last_visited_customers"
            (ttModelChange)="onShowLastVisitedCustomersChanged($event)"
        ></tt-checkbox>
        <tt-button-goto ttText="create_new_customer" ttGoto="customeredit" [ttGotoParms]="{ cust_no: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>
    <tt-find-customers-list *ngIf="'mobile' | mediaQuery" [page]="page"></tt-find-customers-list>
    <tt-find-customers-grid *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery" [page]="page" [(grid)]="grid"></tt-find-customers-grid>
    <tt-card>
        <tt-button-settings *ngIf="page.show_setting === '1'"></tt-button-settings>
    </tt-card>
</ng-container>
